import { useOverlayContext } from '~/contexts';
import { clientsBulkActionResultModalContent, clientsBulkDeleteConfirmationContent } from '../modals/clientsBulkActionModals';
export function useClientBulkActions(param) {
    let { texts, getSelectedIds, onExportSelected, onComplete } = param;
    const { showModal } = useOverlayContext();
    const showResultModal = (actionType, ids)=>showModal({
            biName: 'clients_bulk_action_result_modal',
            content: clientsBulkActionResultModalContent({
                actionType,
                ids,
                onComplete
            })
        });
    return {
        onBulkExport: ()=>onExportSelected(getSelectedIds()),
        onBulkArchive: async ()=>{
            const ids = getSelectedIds();
            if (ids.length === 0) return;
            await showResultModal('archive', ids);
        },
        onBulkDelete: async ()=>{
            const ids = getSelectedIds();
            if (ids.length === 0) return;
            const confirmed = await showModal({
                biName: 'clients_dashboard_bulk_delete_confirmation_confirm',
                content: clientsBulkDeleteConfirmationContent({
                    count: ids.length,
                    texts
                })
            });
            if (!confirmed) return;
            await showResultModal('delete', ids);
        }
    };
}
